import { render, staticRenderFns } from "./ProfileBox.vue?vue&type=template&id=08620cf9&scoped=true&"
import script from "./ProfileBox.vue?vue&type=script&lang=js&"
export * from "./ProfileBox.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBox.vue?vue&type=style&index=0&id=08620cf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08620cf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
